<script setup lang="ts">
import { ZhSectionHeading, ZhStatusPill } from '@zerohuman/ui'
import type { RunStatusTone } from '@/lib/statusTone'

/*
 * A Blockers section heading: the kit heading (it owns the type) with the section's alert count as the kit status
 * pill (it owns the colour). What stays here is the meaning, not the look: the title, a count shown only when
 * above zero, and the tone that says which kind of alert the section holds.
 */
withDefaults(
    defineProps<{
        title: string
        /** Alerts in this section. Shown only when above zero; all sections add up to the sidebar badge. */
        count: number
        /*
         * BG §18.4 — a section of gates queued behind a human is not the same news as a section of runs
         * that cannot start, so the count says which of the two it is instead of painting both magenta.
         */
        tone?: RunStatusTone
    }>(),
    { tone: 'failed' },
)
</script>

<template>
	<ZhSectionHeading>
		{{ title }}
		<template v-if="count > 0" #count>
			<ZhStatusPill :tone="tone" :count="count" :pulse="false" :data-blocker-tone="tone" />
		</template>
	</ZhSectionHeading>
</template>
